t = require('views/internal/teacup-with-helpers')('member_cards_group')

module.exports = t.renderable ({ group, organizations }) ->
  outputGroup = (id, text) ->
    t.li { class: t.classify('active': group == id) }, ->
      t.a '.highlight-icon.js-set-group', { href: '#', 'data-group': id }, ->
          t.text text
          t.text ' '
          if group == id
            t.icon 'check'
            t.text ' '

  t.ul '.pop-over-list.checkable', ->
    outputGroup('all', t.l('all-boards'))
    outputGroup('personal', t.l('personal-boards'))
    organizations.forEach (org) ->
      outputGroup(org.id, org.name)




// WEBPACK FOOTER //
// ./app/scripts/views/templates/member_cards_group.coffee